import {isDefined} from "@/utils";
import backend from "@/mm-backend";
import {logger} from "@/main";
import {Room} from "@/entities/Room";

export class AppointmentsStorage {

    constructor() {
        this._appointments = [];
        this._rooms = [];
        this._users = [];
        this._events = [];
    }


    loadRooms() {
        return new Promise((resolve, reject) => {
            backend.getAllRooms().then(resp => {
                logger.log("Rooms loaded");
                if(isDefined(resp.data)){
                    this._rooms = resp.data.map(r => new Room(r))
                }
                resolve(this._rooms);
            }, error => {
                reject(error);
            });
        });
    }


    getAppointments() {
        return this._appointments;
    }

    setAppointments(appointments) {
        if (isDefined(appointments) && Array.isArray(appointments)) {
            this._appointments = appointments;
        }
    }

    getUsers() {
        return this._users;
    }

    getAllRoomsFromAllHalls(){
        const rooms = [];
        if(!isDefined(this._rooms)){
            return [];
        }
        for(const room of this._rooms){
            if(isDefined(room.halls)){
                for(const [key,value] of Object.entries(room.halls)){
                    rooms.push(...value)
                }
            }
        }

        return rooms;
    }

    getUserById(userId) {
        for (const u of this._users) {
            if (+u.id === +userId) {
                return u;
            }
        }
        return undefined;
    }

    setUsers(users) {
        if (isDefined(users) && Array.isArray(users)) {
            this._users = users;
        }
    }

    getRooms() {
        return this._rooms;
    }

    setRooms(rooms) {
        if (isDefined(rooms) && Array.isArray(rooms)) {
            this._rooms = rooms;
        }
    }

    hasHalls(){
        for (const r of this._rooms) {
            if (!r.halls || r.halls.length === 0) {
                continue
            }
            return true
        }
        return false;
    }

    getRoomById(roomId) {
        for (const r of this._rooms) {
            if (r.id === roomId) {
                return r;
            }
        }
        return undefined;
    }

    getHalls(create_custom_hall) {
        const halls = [];
        if(create_custom_hall){
            halls.push({name: 'other', stands: []});
        }
        for (const r of this._rooms) {
            if (!r.halls) {
                continue
            }
            for (const [key, value] of Object.entries(r.halls)) {
                halls.push({
                    name: key,
                    stands: value
                });
            }
        }
        return halls;
    }

    getHallByStandId(standId) {
        for (const r of this._rooms) {
            if (!r.halls) {
                continue
            }
            for (const [key, value] of Object.entries(r.halls)) {
                const stand = value.find(s => s.id === standId);
                if (stand) {
                    return {
                        name: key,
                        stands: value
                    };
                }
            }
        }
    }

    getStandName(standId) {
        for (const r of this._rooms) {
            if (!r.halls) {
                continue
            }
            for (const [key, value] of Object.entries(r.halls)) {
                const stand = value.find(s => s.id === standId);
                if (stand) {
                    if (stand.label) {
                        return `${key} ${stand.name} - ${stand.label}`;
                    } else {
                        return `${key} ${stand.name}`;
                    }
                }
            }
        }
    }

    setEvents(events) {
        if (isDefined(events) && Array.isArray(events)) {
            this._events = events;
        }
    }

    getEvents() {
        return this._events;
    }

}

